import React from 'react';
import {useIntl} from 'react-intl';
import styled from 'styled-components';
import {WarningIcon} from '@/web-components/design-icons';
import {PercentageInputWrapper} from '../../../components/inputs/percentage_input_wrapper';
import {CSS_CONSTANTS} from '../../../css_variables';

const ThresholdWrapper = styled.div`
	border: 1px solid ${CSS_CONSTANTS.v2_border_gray};
	border-radius: 4px;
	padding: 16px;
`;

const ThresholdRow = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	&:last-child {
		margin-bottom: 0;
	}
`;

const Text = styled.div`
	font-size: 13px;
	color: ${CSS_CONSTANTS.v2_text_gray};
	margin: 0 4px;
`;

const TitleText = styled(Text)`
	margin: 0 0 24px 0;
`;

export const BudgetThresholdsUpdateForm = ({revenueMarginLow, revenueMarginHigh, callback}) => {
	const intl = useIntl();

	const updateLow = marginLow => {
		if (marginLow < 0 || marginLow > 1) {
			return;
		}
		const updatedMarginHigh = marginLow > revenueMarginHigh ? marginLow : revenueMarginHigh;
		callback(marginLow, updatedMarginHigh);
	};

	const updateHigh = marginHigh => {
		if (marginHigh < 0 || marginHigh > 1) {
			return;
		}
		const updatedMarginLow = revenueMarginLow > marginHigh ? marginHigh : revenueMarginLow;
		callback(updatedMarginLow, marginHigh);
	};

	return (
		<ThresholdWrapper>
			<TitleText>Warn me when the project total billable time and expenses at completion is more than:</TitleText>
			<ThresholdRow>
				<PercentageInputWrapper
					intl={intl}
					value={revenueMarginLow != null ? revenueMarginLow * 100 : 0}
					callback={value => updateLow(value)}
					placeholder={'%'}
					width={'75px'}
					zeroToHundred
				/>
				<Text>of the fixed price budget</Text>
				<WarningIcon variant={WarningIcon.VARIANT.WARNING} />
			</ThresholdRow>
			<ThresholdRow>
				<PercentageInputWrapper
					intl={intl}
					value={revenueMarginHigh != null ? revenueMarginHigh * 100 : 0}
					callback={value => updateHigh(value)}
					placeholder={'%'}
					width={'75px'}
					zeroToHundred
				/>
				<Text>of the fixed price budget</Text>
				<WarningIcon variant={WarningIcon.VARIANT.DANGER} />
			</ThresholdRow>
		</ThresholdWrapper>
	);
};
